import { isName } from './is-name';

export function validateFirstName(firstName: string): true | string {
  return isName(firstName) || 'Invalid characters in first name';
}
